import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import {
	type AnalyticsAttributes,
	fireOperationalAnalytics,
	MountEvent,
} from '@atlassian/analytics-bridge';
import React from 'react';

const COMPONENT_MOUNTED_EVENT_ACTION = 'mounted';

export default (componentName: string) => (attributes: AnalyticsAttributes) => (
	<MountEvent
		onMount={(analyticsEvent: UIAnalyticsEvent) =>
			fireOperationalAnalytics(
				analyticsEvent,
				`${componentName} ${COMPONENT_MOUNTED_EVENT_ACTION}`,
				{ attributes },
			)
		}
	/>
);
